import { render } from "./TaskOverview.vue?vue&type=template&id=ca3c7af2&ts=true"
import script from "./TaskOverview.vue?vue&type=script&lang=ts"
export * from "./TaskOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__